function base64url(bytes: Uint8Array): string {
  let s = '';
  for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '');
}

/** 256-bit booking access token. Only its SHA-256 is stored server-side. */
export function newAccessToken(): string {
  return base64url(crypto.getRandomValues(new Uint8Array(32)));
}

/** Idempotency key for a single user intent (safe to resend). */
export function newIdempotencyKey(): string {
  return base64url(crypto.getRandomValues(new Uint8Array(18)));
}
